import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import {
  MealCreditLength,
  MONTHLY_DEFAULT_BUDGET_RESET_PERIOD,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

interface CalculateConsecutiveMonthsProps {
  budgetLength: MealCreditLength;
  budgetResetType: BudgetResetTypeValues;
  budgetResetPeriod: string | number;
}

export function calculateConsecutiveMonthsBasedOnBudgetLength({
  budgetLength,
  budgetResetType,
  budgetResetPeriod,
}: CalculateConsecutiveMonthsProps): number | null {
  const period = Number(budgetResetPeriod);
  const isValidPeriod = period > 0;

  const isCustomMonthlyBudget =
    budgetLength === MealCreditLength.CUSTOM &&
    budgetResetType === BudgetResetTypeValues.MONTHS;

  if (isCustomMonthlyBudget && isValidPeriod) {
    return period;
  }

  return MONTHLY_DEFAULT_BUDGET_RESET_PERIOD;
}
